import { observer } from "mobx-react-lite";
import { VirtualizedItemList } from "@/components/item-list";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { TemplatesListPageEmpty } from "@/pages/templates-list/components/templates-list-page-list-empty";

export const TemplatesListPageList = observer(() => {
  const page = useTabPageStore("templatesListPage");

  if (!page.itemRows.length) {
    return <TemplatesListPageEmpty />;
  }

  return <VirtualizedItemList rows={page.itemRows} loading={false} />;
});
